<template>
  <div>
    <label class="error" v-for="item in errors" :key="item">
      {{ item }}
    </label>
  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import { filter, forEach } from 'lodash';
import { translations } from '@/mixins';

export default {
  name: 'FormError',
  props: ['model', 'dirty', 'label', 'sameAs'],
  mixins: [translations],
  computed: {
    errors() {
      // eslint-disable-next-line consistent-return
      const validationErrors = filter(this.model.$params, (item, index) => {
        // item can be null when validating array, so we need to check it here is item available
        if (item?.type === 'requiredIf' && !this.model.required && this.dirty) {
          return item;
        }

        // validating array items
        if (index === '$each') {
          console.log('model: ', this.model);
          // forEach(this.model.$each.$iter, (item, index) => {
          //   console.log('$iter', item, index);
          // });
        }
        if (!this.model[index] && this.dirty) {
          return item;
        }
      });

      const messages = validationErrors.map((item) => {
        switch (item.type) {
          case 'required':
          case 'requiredIf':
            return this.translations.forms.errors.required.replace('{field}', `"${this.label}"`);
          case 'minLength':
            return this.translations.forms.errors.minLength.replace('{count}', item.min);
          case 'integer':
          case 'numeric':
          case 'decimal':
            return this.translations.forms.errors.integer.replace('{field}', `"${this.label}"`);
          case 'email':
            return this.translations.forms.errors.email.replace('{field}', `"${this.label}"`);
          case 'url':
            return this.translations.forms.errors.url.replace('{field}', `"${this.label}"`);
          case 'sameAs':
            return this.translations.forms.errors.sameAs
              .replace('{field}', `"${this.label}"`)
              .replace('{field2}', `"${this.sameAs}"`);
          default:
            console.log(item);
            return this.translations.forms.errors.default;
        }
      });
      return messages;
    },
  },
};
</script>

<style lang="scss" scoped>
label.error {
  width: 100%;
  color: #d2322d;
}
</style>
